/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-7c760541.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _circle, _circle2, _circle3, _circle4, _path75, _path76, _circle5, _circle6, _circle7, _circle8, _path77, _path78, _circle9, _circle10, _circle11, _circle12, _path79, _path80, _circle13, _circle14, _circle15, _circle16, _path81, _path82, _circle17, _circle18, _circle19, _circle20, _path83, _path84, _path85, _path86, _circle21, _circle22, _circle23, _circle24, _path87, _path88, _path89, _path90, _circle25, _circle26, _circle27, _circle28, _path91, _path92, _path93, _path94, _circle29, _circle30, _circle31, _circle32, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _circle33, _circle34, _circle35, _circle36, _circle37, _path170, _path171, _circle38, _circle39, _circle40, _circle41, _circle42, _path172, _path173, _circle43, _circle44, _circle45, _circle46, _circle47, _path174, _path175, _circle48, _circle49, _circle50, _circle51, _circle52, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _circle53, _circle54, _circle55, _circle56, _circle57, _path185, _path186, _circle58, _circle59, _circle60, _circle61, _circle62, _path187, _path188, _circle63, _circle64, _circle65, _circle66, _circle67, _path189, _path190, _circle68, _circle69, _circle70, _circle71, _circle72, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _circle73, _circle74, _circle75, _path293, _circle76, _circle77, _circle78, _path294, _circle79, _circle80, _circle81, _path295, _circle82, _circle83, _circle84, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _circle85, _path310, _path311, _circle86, _path312, _path313, _circle87, _path314, _path315, _circle88, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _circle89, _path333, _circle90, _path334, _circle91, _path335, _circle92, _path336, _circle93, _path337, _circle94, _path338, _circle95, _path339, _circle96, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394;

var ForecastLightning_3032 = /*#__PURE__*/React.forwardRef(function ForecastLightning_3032(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
  })), children);
});
var ForecastLightning_3024 = /*#__PURE__*/React.forwardRef(function ForecastLightning_3024(_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
  })), children);
});
var ForecastLightning_3020 = /*#__PURE__*/React.forwardRef(function ForecastLightning_3020(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
  })), children);
});
var ForecastLightning_3016 = /*#__PURE__*/React.forwardRef(function ForecastLightning_3016(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24zM20 20H16v2h4v2H17v2h3v2H16v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0020 20zM28 30H26a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zm-2-8v6h2V22z"
  })), children);
});
var Fork32 = /*#__PURE__*/React.forwardRef(function Fork32(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z"
  })), children);
});
var Fork24 = /*#__PURE__*/React.forwardRef(function Fork24(_ref6, ref) {
  var children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z"
  })), children);
});
var Fork20 = /*#__PURE__*/React.forwardRef(function Fork20(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z"
  })), children);
});
var Fork16 = /*#__PURE__*/React.forwardRef(function Fork16(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18a3.9962,3.9962,0,0,0-3.8579,3H17V11h5.1421a4,4,0,1,0,0-2H17a2.002,2.002,0,0,0-2,2v4H9.8579a4,4,0,1,0,0,2H15v4a2.002,2.002,0,0,0,2,2h5.1421A3.9934,3.9934,0,1,0,26,18ZM26,8a2,2,0,1,1-2,2A2.002,2.002,0,0,1,26,8ZM6,18a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,18Zm20,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,26,24Z"
  })), children);
});
var Forum32 = /*#__PURE__*/React.forwardRef(function Forum32(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\tC30,6.8,29.2,6,28,6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
  })), children);
});
var Forum24 = /*#__PURE__*/React.forwardRef(function Forum24(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\tC30,6.8,29.2,6,28,6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
  })), children);
});
var Forum20 = /*#__PURE__*/React.forwardRef(function Forum20(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\tC30,6.8,29.2,6,28,6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
  })), children);
});
var Forum16 = /*#__PURE__*/React.forwardRef(function Forum16(_ref12, ref) {
  var children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8\tC30,6.8,29.2,6,28,6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
  })), children);
});
var Forward_1032 = /*#__PURE__*/React.forwardRef(function Forward_1032(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
  })), children);
});
var Forward_1024 = /*#__PURE__*/React.forwardRef(function Forward_1024(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
  })), children);
});
var Forward_1020 = /*#__PURE__*/React.forwardRef(function Forward_1020(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
  })), children);
});
var Forward_1016 = /*#__PURE__*/React.forwardRef(function Forward_1016(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
  })), children);
});
var Forward_3032 = /*#__PURE__*/React.forwardRef(function Forward_3032(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
  })), children);
});
var Forward_3024 = /*#__PURE__*/React.forwardRef(function Forward_3024(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
  })), children);
});
var Forward_3020 = /*#__PURE__*/React.forwardRef(function Forward_3020(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
  })), children);
});
var Forward_3016 = /*#__PURE__*/React.forwardRef(function Forward_3016(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
  })), children);
});
var Forward_532 = /*#__PURE__*/React.forwardRef(function Forward_532(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
  })), children);
});
var Forward_524 = /*#__PURE__*/React.forwardRef(function Forward_524(_ref22, ref) {
  var children = _ref22.children,
      rest = _objectWithoutProperties(_ref22, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
  })), children);
});
var Forward_520 = /*#__PURE__*/React.forwardRef(function Forward_520(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
  })), children);
});
var Forward_516 = /*#__PURE__*/React.forwardRef(function Forward_516(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
  })), children);
});
var Fragile32 = /*#__PURE__*/React.forwardRef(function Fragile32(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
  })), children);
});
var Fragile24 = /*#__PURE__*/React.forwardRef(function Fragile24(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
  })), children);
});
var Fragile20 = /*#__PURE__*/React.forwardRef(function Fragile20(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
  })), children);
});
var Fragile16 = /*#__PURE__*/React.forwardRef(function Fragile16(_ref28, ref) {
  var children = _ref28.children,
      rest = _objectWithoutProperties(_ref28, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
  })), children);
});
var FruitBowl32 = /*#__PURE__*/React.forwardRef(function FruitBowl32(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
  })), children);
});
var FruitBowl24 = /*#__PURE__*/React.forwardRef(function FruitBowl24(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
  })), children);
});
var FruitBowl20 = /*#__PURE__*/React.forwardRef(function FruitBowl20(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
  })), children);
});
var FruitBowl16 = /*#__PURE__*/React.forwardRef(function FruitBowl16(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
  })), children);
});
var Function32 = /*#__PURE__*/React.forwardRef(function Function32(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
  })), children);
});
var Function24 = /*#__PURE__*/React.forwardRef(function Function24(_ref34, ref) {
  var children = _ref34.children,
      rest = _objectWithoutProperties(_ref34, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
  })), children);
});
var Function20 = /*#__PURE__*/React.forwardRef(function Function20(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
  })), children);
});
var Function16 = /*#__PURE__*/React.forwardRef(function Function16(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
  })), children);
});
var FunctionMath32 = /*#__PURE__*/React.forwardRef(function FunctionMath32(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
  })), children);
});
var FunctionMath24 = /*#__PURE__*/React.forwardRef(function FunctionMath24(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
  })), children);
});
var FunctionMath20 = /*#__PURE__*/React.forwardRef(function FunctionMath20(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
  })), children);
});
var FunctionMath16 = /*#__PURE__*/React.forwardRef(function FunctionMath16(_ref40, ref) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18zM19 6V4H13.9133a1.9906 1.9906 0 00-1.9919 1.8188L11.2686 13H7v2h4.0867l-1 11H5v2h5.0867a1.9906 1.9906 0 001.9919-1.8188L13.0952 15H18V13H13.2769l.6364-7z"
  })), children);
});
var WatsonHealthFusionBlender32 = /*#__PURE__*/React.forwardRef(function WatsonHealthFusionBlender32(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
  })), children);
});
var WatsonHealthFusionBlender24 = /*#__PURE__*/React.forwardRef(function WatsonHealthFusionBlender24(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
  })), children);
});
var WatsonHealthFusionBlender20 = /*#__PURE__*/React.forwardRef(function WatsonHealthFusionBlender20(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
  })), children);
});
var WatsonHealthFusionBlender16 = /*#__PURE__*/React.forwardRef(function WatsonHealthFusionBlender16(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
  })), children);
});
var GameConsole32 = /*#__PURE__*/React.forwardRef(function GameConsole32(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "12",
    r: "1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "14",
    r: "1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "14",
    r: "1"
  })), children);
});
var GameConsole24 = /*#__PURE__*/React.forwardRef(function GameConsole24(_ref46, ref) {
  var children = _ref46.children,
      rest = _objectWithoutProperties(_ref46, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "12",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "14",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "14",
    r: "1"
  })), children);
});
var GameConsole20 = /*#__PURE__*/React.forwardRef(function GameConsole20(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "12",
    r: "1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "14",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "14",
    r: "1"
  })), children);
});
var GameConsole16 = /*#__PURE__*/React.forwardRef(function GameConsole16(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "12",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "14",
    r: "1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "14",
    r: "1"
  })), children);
});
var GameWireless32 = /*#__PURE__*/React.forwardRef(function GameWireless32(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "20",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "18",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "18",
    r: "1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
  })), children);
});
var GameWireless24 = /*#__PURE__*/React.forwardRef(function GameWireless24(_ref50, ref) {
  var children = _ref50.children,
      rest = _objectWithoutProperties(_ref50, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "20",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "18",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "18",
    r: "1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
  })), children);
});
var GameWireless20 = /*#__PURE__*/React.forwardRef(function GameWireless20(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "20",
    r: "1"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "18",
    r: "1"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "18",
    r: "1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
  })), children);
});
var GameWireless16 = /*#__PURE__*/React.forwardRef(function GameWireless16(_ref52, ref) {
  var children = _ref52.children,
      rest = _objectWithoutProperties(_ref52, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "20",
    r: "1"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "18",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "18",
    r: "1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
  })), children);
});
var Gamification32 = /*#__PURE__*/React.forwardRef(function Gamification32(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
  })), children);
});
var Gamification24 = /*#__PURE__*/React.forwardRef(function Gamification24(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
  })), children);
});
var Gamification20 = /*#__PURE__*/React.forwardRef(function Gamification20(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
  })), children);
});
var Gamification16 = /*#__PURE__*/React.forwardRef(function Gamification16(_ref56, ref) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
  })), children);
});
var GasStation32 = /*#__PURE__*/React.forwardRef(function GasStation32(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H15V12H8z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
  })), children);
});
var GasStation24 = /*#__PURE__*/React.forwardRef(function GasStation24(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H15V12H8z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
  })), children);
});
var GasStation20 = /*#__PURE__*/React.forwardRef(function GasStation20(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H15V12H8z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
  })), children);
});
var GasStation16 = /*#__PURE__*/React.forwardRef(function GasStation16(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H15V12H8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
  })), children);
});
var GasStationFilled32 = /*#__PURE__*/React.forwardRef(function GasStationFilled32(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H15V12H8z",
    "data-icon-path": "inner-path"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
  })), children);
});
var GasStationFilled24 = /*#__PURE__*/React.forwardRef(function GasStationFilled24(_ref62, ref) {
  var children = _ref62.children,
      rest = _objectWithoutProperties(_ref62, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H15V12H8z",
    "data-icon-path": "inner-path"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
  })), children);
});
var GasStationFilled20 = /*#__PURE__*/React.forwardRef(function GasStationFilled20(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H15V12H8z",
    "data-icon-path": "inner-path"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
  })), children);
});
var GasStationFilled16 = /*#__PURE__*/React.forwardRef(function GasStationFilled16(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H15V12H8z",
    "data-icon-path": "inner-path"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
  })), children);
});
var GenderFemale32 = /*#__PURE__*/React.forwardRef(function GenderFemale32(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
  })), children);
});
var GenderFemale24 = /*#__PURE__*/React.forwardRef(function GenderFemale24(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
  })), children);
});
var GenderFemale20 = /*#__PURE__*/React.forwardRef(function GenderFemale20(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
  })), children);
});
var GenderFemale16 = /*#__PURE__*/React.forwardRef(function GenderFemale16(_ref68, ref) {
  var children = _ref68.children,
      rest = _objectWithoutProperties(_ref68, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
  })), children);
});
var GenderMale32 = /*#__PURE__*/React.forwardRef(function GenderMale32(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
  })), children);
});
var GenderMale24 = /*#__PURE__*/React.forwardRef(function GenderMale24(_ref70, ref) {
  var children = _ref70.children,
      rest = _objectWithoutProperties(_ref70, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
  })), children);
});
var GenderMale20 = /*#__PURE__*/React.forwardRef(function GenderMale20(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
  })), children);
});
var GenderMale16 = /*#__PURE__*/React.forwardRef(function GenderMale16(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
  })), children);
});
var GeneratePdf32 = /*#__PURE__*/React.forwardRef(function GeneratePdf32(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
  })), children);
});
var GeneratePdf24 = /*#__PURE__*/React.forwardRef(function GeneratePdf24(_ref74, ref) {
  var children = _ref74.children,
      rest = _objectWithoutProperties(_ref74, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
  })), children);
});
var GeneratePdf20 = /*#__PURE__*/React.forwardRef(function GeneratePdf20(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
  })), children);
});
var GeneratePdf16 = /*#__PURE__*/React.forwardRef(function GeneratePdf16(_ref76, ref) {
  var children = _ref76.children,
      rest = _objectWithoutProperties(_ref76, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21zM28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4zM17 12H13V2h4a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0117 12zm-2-2h2a1.0011 1.0011 0 001-1V5a1.0011 1.0011 0 00-1-1H15zM9 2H4V12H6V9H9a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 009 2zM6 7V4H9l.001 3z"
  })), children);
});
var Gif32 = /*#__PURE__*/React.forwardRef(function Gif32(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
  })), children);
});
var Gif24 = /*#__PURE__*/React.forwardRef(function Gif24(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
  })), children);
});
var Gif20 = /*#__PURE__*/React.forwardRef(function Gif20(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
  })), children);
});
var Gif16 = /*#__PURE__*/React.forwardRef(function Gif16(_ref80, ref) {
  var children = _ref80.children,
      rest = _objectWithoutProperties(_ref80, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12v8a3 3 0 003 3h5V15H6v2H8v4H5a1 1 0 01-1-1V12a1 1 0 011-1h5V9H5A3 3 0 002 12zM30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
  })), children);
});
var Gift32 = /*#__PURE__*/React.forwardRef(function Gift32(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
  })), children);
});
var Gift24 = /*#__PURE__*/React.forwardRef(function Gift24(_ref82, ref) {
  var children = _ref82.children,
      rest = _objectWithoutProperties(_ref82, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
  })), children);
});
var Gift20 = /*#__PURE__*/React.forwardRef(function Gift20(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
  })), children);
});
var Gift16 = /*#__PURE__*/React.forwardRef(function Gift16(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
  })), children);
});
var Globe32 = /*#__PURE__*/React.forwardRef(function Globe32(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
  })), children);
});
var Globe24 = /*#__PURE__*/React.forwardRef(function Globe24(_ref86, ref) {
  var children = _ref86.children,
      rest = _objectWithoutProperties(_ref86, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
  })), children);
});
var Globe20 = /*#__PURE__*/React.forwardRef(function Globe20(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
  })), children);
});
var Globe16 = /*#__PURE__*/React.forwardRef(function Globe16(_ref88, ref) {
  var children = _ref88.children,
      rest = _objectWithoutProperties(_ref88, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
  })), children);
});
var Gradient32 = /*#__PURE__*/React.forwardRef(function Gradient32(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
  })), children);
});
var Gradient24 = /*#__PURE__*/React.forwardRef(function Gradient24(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
  })), children);
});
var Gradient20 = /*#__PURE__*/React.forwardRef(function Gradient20(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
  })), children);
});
var Gradient16 = /*#__PURE__*/React.forwardRef(function Gradient16(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H18V14H14zM14 18H18V22H14zM18 14H22V18H18z"
  })), children);
});
var GraphicalDataFlow32 = /*#__PURE__*/React.forwardRef(function GraphicalDataFlow32(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
  })), children);
});
var GraphicalDataFlow24 = /*#__PURE__*/React.forwardRef(function GraphicalDataFlow24(_ref94, ref) {
  var children = _ref94.children,
      rest = _objectWithoutProperties(_ref94, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
  })), children);
});
var GraphicalDataFlow20 = /*#__PURE__*/React.forwardRef(function GraphicalDataFlow20(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
  })), children);
});
var GraphicalDataFlow16 = /*#__PURE__*/React.forwardRef(function GraphicalDataFlow16(_ref96, ref) {
  var children = _ref96.children,
      rest = _objectWithoutProperties(_ref96, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H22a2.0023 2.0023 0 01-2-2V22a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 30zm-6-8h-.0012L22 28h6V22zM18 26H12a3.0033 3.0033 0 01-3-3V19h2v4a1.001 1.001 0 001 1h6zM26 18H24V15a1.001 1.001 0 00-1-1H18V12h5a3.0033 3.0033 0 013 3zM15 18a.9986.9986 0 01-.4971-.1323L10 15.2886 5.4968 17.8677a1 1 0 01-1.4712-1.0938l1.0618-4.572L2.269 9.1824a1 1 0 01.5662-1.6687l4.2-.7019L9.1006 2.5627a1 1 0 011.7881-.0214l2.2046 4.271 4.0764.7021a1 1 0 01.5613 1.668l-2.8184 3.02 1.0613 4.5718A1 1 0 0115 18zm-5-5s.343.18.4971.2686l3.01 1.7241-.7837-3.3763 2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829 8.6144l-3.3809.565 2.2745 2.437-.7841 3.3763 3.0105-1.7241C9.657 13.18 10 13 10 13z"
  })), children);
});
var Grid32 = /*#__PURE__*/React.forwardRef(function Grid32(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
  })), children);
});
var Grid24 = /*#__PURE__*/React.forwardRef(function Grid24(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
  })), children);
});
var Grid20 = /*#__PURE__*/React.forwardRef(function Grid20(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
  })), children);
});
var Grid16 = /*#__PURE__*/React.forwardRef(function Grid16(_ref100, ref) {
  var children = _ref100.children,
      rest = _objectWithoutProperties(_ref100, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0012 4zm0 8H6V6h6zM26 4H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6A2 2 0 0026 4zm0 8H20V6h6zM12 18H6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0012 18zm0 8H6V20h6zM26 18H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V20A2 2 0 0026 18zm0 8H20V20h6z"
  })), children);
});
var Group32 = /*#__PURE__*/React.forwardRef(function Group32(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
  })), children);
});
var Group24 = /*#__PURE__*/React.forwardRef(function Group24(_ref102, ref) {
  var children = _ref102.children,
      rest = _objectWithoutProperties(_ref102, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
  })), children);
});
var Group20 = /*#__PURE__*/React.forwardRef(function Group20(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
  })), children);
});
var Group16 = /*#__PURE__*/React.forwardRef(function Group16(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30H29V27a3 3 0 00-3-3H22a3 3 0 00-3 3v3H17V27a5 5 0 015-5h4a5 5 0 015 5zM24 12a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 10zM15 22H13V19a3 3 0 00-3-3H6a3 3 0 00-3 3v3H1V19a5 5 0 015-5h4a5 5 0 015 5zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
  })), children);
});
var GroupPresentation32 = /*#__PURE__*/React.forwardRef(function GroupPresentation32(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "22",
    r: "2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "22",
    r: "2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "22",
    r: "2"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "18",
    r: "2"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "18",
    r: "2"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
  })), children);
});
var GroupPresentation24 = /*#__PURE__*/React.forwardRef(function GroupPresentation24(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "22",
    r: "2"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "22",
    r: "2"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "22",
    r: "2"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "18",
    r: "2"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "18",
    r: "2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
  })), children);
});
var GroupPresentation20 = /*#__PURE__*/React.forwardRef(function GroupPresentation20(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "22",
    r: "2"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "22",
    r: "2"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "22",
    r: "2"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "18",
    r: "2"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "18",
    r: "2"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
  })), children);
});
var GroupPresentation16 = /*#__PURE__*/React.forwardRef(function GroupPresentation16(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30H8V27H4v3H2V27a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2zM30 30H28V27H24v3H22V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2zM20 30H18V27H14v3H12V27a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2z"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "22",
    r: "2"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "22",
    r: "2"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "22",
    r: "2"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "18",
    r: "2"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "18",
    r: "2"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
  })), children);
});
var Growth32 = /*#__PURE__*/React.forwardRef(function Growth32(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
  })), children);
});
var Growth24 = /*#__PURE__*/React.forwardRef(function Growth24(_ref110, ref) {
  var children = _ref110.children,
      rest = _objectWithoutProperties(_ref110, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
  })), children);
});
var Growth20 = /*#__PURE__*/React.forwardRef(function Growth20(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
  })), children);
});
var Growth16 = /*#__PURE__*/React.forwardRef(function Growth16(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
  })), children);
});
var QH32 = /*#__PURE__*/React.forwardRef(function QH32(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), children);
});
var QH24 = /*#__PURE__*/React.forwardRef(function QH24(_ref114, ref) {
  var children = _ref114.children,
      rest = _objectWithoutProperties(_ref114, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), children);
});
var QH20 = /*#__PURE__*/React.forwardRef(function QH20(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), children);
});
var QH16 = /*#__PURE__*/React.forwardRef(function QH16(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), children);
});
var Hail32 = /*#__PURE__*/React.forwardRef(function Hail32(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "29.5",
    r: "1.5"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "25.5",
    r: "1.5"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "25.5",
    r: "1.5"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.5",
    cy: "29.5",
    r: "1.5"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.499",
    cy: "29.5",
    r: "1.5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
  })), children);
});
var Hail24 = /*#__PURE__*/React.forwardRef(function Hail24(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "29.5",
    r: "1.5"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "25.5",
    r: "1.5"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "25.5",
    r: "1.5"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.5",
    cy: "29.5",
    r: "1.5"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.499",
    cy: "29.5",
    r: "1.5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
  })), children);
});
var Hail20 = /*#__PURE__*/React.forwardRef(function Hail20(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "29.5",
    r: "1.5"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "25.5",
    r: "1.5"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "25.5",
    r: "1.5"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.5",
    cy: "29.5",
    r: "1.5"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.499",
    cy: "29.5",
    r: "1.5"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
  })), children);
});
var Hail16 = /*#__PURE__*/React.forwardRef(function Hail16(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "29.5",
    r: "1.5"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "25.5",
    r: "1.5"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "25.5",
    r: "1.5"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.5",
    cy: "29.5",
    r: "1.5"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.499",
    cy: "29.5",
    r: "1.5"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
  })), children);
});
var WatsonHealthHangingProtocol32 = /*#__PURE__*/React.forwardRef(function WatsonHealthHangingProtocol32(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
  })), children);
});
var WatsonHealthHangingProtocol24 = /*#__PURE__*/React.forwardRef(function WatsonHealthHangingProtocol24(_ref122, ref) {
  var children = _ref122.children,
      rest = _objectWithoutProperties(_ref122, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
  })), children);
});
var WatsonHealthHangingProtocol20 = /*#__PURE__*/React.forwardRef(function WatsonHealthHangingProtocol20(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
  })), children);
});
var WatsonHealthHangingProtocol16 = /*#__PURE__*/React.forwardRef(function WatsonHealthHangingProtocol16(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
  })), children);
});
var Harbor32 = /*#__PURE__*/React.forwardRef(function Harbor32(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
  })), children);
});
var Harbor24 = /*#__PURE__*/React.forwardRef(function Harbor24(_ref126, ref) {
  var children = _ref126.children,
      rest = _objectWithoutProperties(_ref126, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
  })), children);
});
var Harbor20 = /*#__PURE__*/React.forwardRef(function Harbor20(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
  })), children);
});
var Harbor16 = /*#__PURE__*/React.forwardRef(function Harbor16(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
  })), children);
});
var Hashtag32 = /*#__PURE__*/React.forwardRef(function Hashtag32(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
  })), children);
});
var Hashtag24 = /*#__PURE__*/React.forwardRef(function Hashtag24(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
  })), children);
});
var Hashtag20 = /*#__PURE__*/React.forwardRef(function Hashtag20(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
  })), children);
});
var Hashtag16 = /*#__PURE__*/React.forwardRef(function Hashtag16(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
  })), children);
});
var Haze32 = /*#__PURE__*/React.forwardRef(function Haze32(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.5H28.5V25.5H24.5z",
    transform: "rotate(45 26.5 24.5)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15H32V17H28z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.5H28.5V8.5H24.5z",
    transform: "rotate(-45 26.5 7.5)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H19V6H17z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5H11.5V8.5H7.5z",
    transform: "rotate(-135 9.5 7.5)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
  })), children);
});
var Haze24 = /*#__PURE__*/React.forwardRef(function Haze24(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.5H28.5V25.5H24.5z",
    transform: "rotate(45 26.5 24.5)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15H32V17H28z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.5H28.5V8.5H24.5z",
    transform: "rotate(-45 26.5 7.5)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H19V6H17z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5H11.5V8.5H7.5z",
    transform: "rotate(-135 9.5 7.5)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
  })), children);
});
var Haze20 = /*#__PURE__*/React.forwardRef(function Haze20(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.5H28.5V25.5H24.5z",
    transform: "rotate(45 26.5 24.5)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15H32V17H28z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.5H28.5V8.5H24.5z",
    transform: "rotate(-45 26.5 7.5)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H19V6H17z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5H11.5V8.5H7.5z",
    transform: "rotate(-135 9.5 7.5)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
  })), children);
});
var Haze16 = /*#__PURE__*/React.forwardRef(function Haze16(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28H3a1 1 0 010-2H19a1 1 0 010 2zM15 20H3a1 1 0 010-2H15a1 1 0 010 2z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.5H28.5V25.5H24.5z",
    transform: "rotate(45 26.5 24.5)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15H32V17H28z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.5H28.5V8.5H24.5z",
    transform: "rotate(-45 26.5 7.5)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H19V6H17z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5H11.5V8.5H7.5z",
    transform: "rotate(-135 9.5 7.5)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
  })), children);
});
var HazeNight32 = /*#__PURE__*/React.forwardRef(function HazeNight32(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
  })), children);
});
var HazeNight24 = /*#__PURE__*/React.forwardRef(function HazeNight24(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
  })), children);
});
var HazeNight20 = /*#__PURE__*/React.forwardRef(function HazeNight20(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
  })), children);
});
var HazeNight16 = /*#__PURE__*/React.forwardRef(function HazeNight16(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20H17a1 1 0 010-2H27a1 1 0 010 2zM25 16H13a1 1 0 010-2H25a1 1 0 010 2z"
  })), children);
});
var Hd32 = /*#__PURE__*/React.forwardRef(function Hd32(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
  })), children);
});
var Hd24 = /*#__PURE__*/React.forwardRef(function Hd24(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
  })), children);
});
var Hd20 = /*#__PURE__*/React.forwardRef(function Hd20(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
  })), children);
});
var Hd16 = /*#__PURE__*/React.forwardRef(function Hd16(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H18V21h4a3 3 0 003-3V14A3 3 0 0022 11zm1 7a1 1 0 01-1 1H20V13h2a1 1 0 011 1zM13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
  })), children);
});
var HdFilled32 = /*#__PURE__*/React.forwardRef(function HdFilled32(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
  })), children);
});
var HdFilled24 = /*#__PURE__*/React.forwardRef(function HdFilled24(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
  })), children);
});
var HdFilled20 = /*#__PURE__*/React.forwardRef(function HdFilled20(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
  })), children);
});
var HdFilled16 = /*#__PURE__*/React.forwardRef(function HdFilled16(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
  })), children);
});
var Hdr32 = /*#__PURE__*/React.forwardRef(function Hdr32(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
  })), children);
});
var Hdr24 = /*#__PURE__*/React.forwardRef(function Hdr24(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
  })), children);
});
var Hdr20 = /*#__PURE__*/React.forwardRef(function Hdr20(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
  })), children);
});
var Hdr16 = /*#__PURE__*/React.forwardRef(function Hdr16(_ref152, ref) {
  var children = _ref152.children,
      rest = _objectWithoutProperties(_ref152, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14zM8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
  })), children);
});
var Headphones32 = /*#__PURE__*/React.forwardRef(function Headphones32(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
  })), children);
});
var Headphones24 = /*#__PURE__*/React.forwardRef(function Headphones24(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
  })), children);
});
var Headphones20 = /*#__PURE__*/React.forwardRef(function Headphones20(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
  })), children);
});
var Headphones16 = /*#__PURE__*/React.forwardRef(function Headphones16(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
  })), children);
});
var Headset32 = /*#__PURE__*/React.forwardRef(function Headset32(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
  })), children);
});
var Headset24 = /*#__PURE__*/React.forwardRef(function Headset24(_ref158, ref) {
  var children = _ref158.children,
      rest = _objectWithoutProperties(_ref158, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
  })), children);
});
var Headset20 = /*#__PURE__*/React.forwardRef(function Headset20(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
  })), children);
});
var Headset16 = /*#__PURE__*/React.forwardRef(function Headset16(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
  })), children);
});
var HealthCross32 = /*#__PURE__*/React.forwardRef(function HealthCross32(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
  })), children);
});
var HealthCross24 = /*#__PURE__*/React.forwardRef(function HealthCross24(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
  })), children);
});
var HealthCross20 = /*#__PURE__*/React.forwardRef(function HealthCross20(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
  })), children);
});
var HealthCross16 = /*#__PURE__*/React.forwardRef(function HealthCross16(_ref164, ref) {
  var children = _ref164.children,
      rest = _objectWithoutProperties(_ref164, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
  })), children);
});
var Hearing32 = /*#__PURE__*/React.forwardRef(function Hearing32(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
  })), children);
});
var Hearing24 = /*#__PURE__*/React.forwardRef(function Hearing24(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
  })), children);
});
var Hearing20 = /*#__PURE__*/React.forwardRef(function Hearing20(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
  })), children);
});
var Hearing16 = /*#__PURE__*/React.forwardRef(function Hearing16(_ref168, ref) {
  var children = _ref168.children,
      rest = _objectWithoutProperties(_ref168, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22V20a2.0023 2.0023 0 002-2h2A4.0042 4.0042 0 0118 22zM10 2a9.01 9.01 0 00-9 9H3a7 7 0 0114 0 7.09 7.09 0 01-3.501 6.1348L13 17.4229v3.0732a2.9354 2.9354 0 01-.9009 2.1514 4.1824 4.1824 0 01-4.6318 1.03A4.0918 4.0918 0 015 20H3a6.1156 6.1156 0 003.6694 5.5117 5.7822 5.7822 0 002.3145.4863A6.5854 6.5854 0 0013.4624 24.11 4.94 4.94 0 0015 20.4961V18.5537A9.1077 9.1077 0 0019 11 9.01 9.01 0 0010 2z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
  })), children);
});
var HeatMap32 = /*#__PURE__*/React.forwardRef(function HeatMap32(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
  })), children);
});
var HeatMap24 = /*#__PURE__*/React.forwardRef(function HeatMap24(_ref170, ref) {
  var children = _ref170.children,
      rest = _objectWithoutProperties(_ref170, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
  })), children);
});
var HeatMap20 = /*#__PURE__*/React.forwardRef(function HeatMap20(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
  })), children);
});
var HeatMap16 = /*#__PURE__*/React.forwardRef(function HeatMap16(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V20H20zM28 16H30V18H28zM14 6H16V8H14zM16 22H12V16a2.0023 2.0023 0 00-2-2H4a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h6v4a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V24A2.0023 2.0023 0 0016 22zM4 22V16h6v6zm8 6V24h4v4zM28 30H24a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0128 30zm-4-6v4h4V24zM28 2H22a2.0023 2.0023 0 00-2 2v6H18a2.0023 2.0023 0 00-2 2v2a2.0023 2.0023 0 002 2h2a2.0023 2.0023 0 002-2V12h6a2.0023 2.0023 0 002-2V4A2.0023 2.0023 0 0028 2zM18 14V12h2v2zm4-4V4h6v6zM8 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 018 10zM4 4V8H8V4z"
  })), children);
});
var HeatMap_0232 = /*#__PURE__*/React.forwardRef(function HeatMap_0232(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "20",
    r: "2"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "12",
    r: "2"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "19",
    r: "1"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
  })), children);
});
var HeatMap_0224 = /*#__PURE__*/React.forwardRef(function HeatMap_0224(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "20",
    r: "2"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "12",
    r: "2"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "19",
    r: "1"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
  })), children);
});
var HeatMap_0220 = /*#__PURE__*/React.forwardRef(function HeatMap_0220(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "20",
    r: "2"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "12",
    r: "2"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "19",
    r: "1"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
  })), children);
});
var HeatMap_0216 = /*#__PURE__*/React.forwardRef(function HeatMap_0216(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "20",
    r: "2"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "12",
    r: "2"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "19",
    r: "1"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30A3.5 3.5 0 1130 26.5 3.5041 3.5041 0 0126.5 30zm0-5A1.5 1.5 0 1028 26.5 1.5017 1.5017 0 0026.5 25zM14 30a3.958 3.958 0 01-2.126-.6211 6.9977 6.9977 0 114.1109-6.8384A3.9916 3.9916 0 0114 30zm-1.8843-3.0278l.5391.4946a1.9915 1.9915 0 102.0039-3.343l-.6909-.2432.03-.8467a5.0085 5.0085 0 10-2.5166 4.3023zM24 16a6.0067 6.0067 0 01-6-6 5.3246 5.3246 0 01.0269-.5327A3.9564 3.9564 0 0116 6a4.0045 4.0045 0 014-4 3.9564 3.9564 0 013.4673 2.0271C23.6484 4.009 23.8252 4 24 4a6 6 0 010 12zM20 4a2.0021 2.0021 0 00-2 2 1.9805 1.9805 0 001.43 1.9023l.9018.2706-.2153.9162A3.9938 3.9938 0 1024 6a4.0064 4.0064 0 00-.9121.1162l-.9155.2141-.27-.9006A1.9807 1.9807 0 0020 4zM6.5 11A4.5 4.5 0 1111 6.5 4.5051 4.5051 0 016.5 11zm0-7A2.5 2.5 0 109 6.5 2.503 2.503 0 006.5 4z"
  })), children);
});
var HeatMap_0332 = /*#__PURE__*/React.forwardRef(function HeatMap_0332(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
  })), children);
});
var HeatMap_0324 = /*#__PURE__*/React.forwardRef(function HeatMap_0324(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
  })), children);
});
var HeatMap_0320 = /*#__PURE__*/React.forwardRef(function HeatMap_0320(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
  })), children);
});
var HeatMap_0316 = /*#__PURE__*/React.forwardRef(function HeatMap_0316(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
  })), children);
});
var HeatMapStocks32 = /*#__PURE__*/React.forwardRef(function HeatMapStocks32(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
  })), children);
});
var HeatMapStocks24 = /*#__PURE__*/React.forwardRef(function HeatMapStocks24(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
  })), children);
});
var HeatMapStocks20 = /*#__PURE__*/React.forwardRef(function HeatMapStocks20(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
  })), children);
});
var HeatMapStocks16 = /*#__PURE__*/React.forwardRef(function HeatMapStocks16(_ref184, ref) {
  var children = _ref184.children,
      rest = _objectWithoutProperties(_ref184, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
  })), children);
});
var Helicopter32 = /*#__PURE__*/React.forwardRef(function Helicopter32(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
  })), children);
});
var Helicopter24 = /*#__PURE__*/React.forwardRef(function Helicopter24(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
  })), children);
});
var Helicopter20 = /*#__PURE__*/React.forwardRef(function Helicopter20(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
  })), children);
});
var Helicopter16 = /*#__PURE__*/React.forwardRef(function Helicopter16(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
  })), children);
});
var Help32 = /*#__PURE__*/React.forwardRef(function Help32(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23.5",
    r: "1.5"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"
  })), children);
});
var Help24 = /*#__PURE__*/React.forwardRef(function Help24(_ref190, ref) {
  var children = _ref190.children,
      rest = _objectWithoutProperties(_ref190, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23.5",
    r: "1.5"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"
  })), children);
});
var Help20 = /*#__PURE__*/React.forwardRef(function Help20(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23.5",
    r: "1.5"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"
  })), children);
});
var Help16 = /*#__PURE__*/React.forwardRef(function Help16(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "11.8",
    r: ".8"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,4H7.8C6.5,4,5.5,5,5.5,6.2c0,0,0,0,0,0v0.2h1V6.2C6.5,5.6,7.1,5,7.8,5h0.8c0.7,0,1.2,0.6,1.2,1.2S9.2,7.5,8.5,7.5h-1\tv2.2h1V8.5c1.2,0,2.2-1,2.2-2.2S9.7,4,8.5,4z"
  })), children);
});
var HelpFilled32 = /*#__PURE__*/React.forwardRef(function HelpFilled32(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
    "data-icon-path": "inner-path"
  })), children);
});
var HelpFilled24 = /*#__PURE__*/React.forwardRef(function HelpFilled24(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
    "data-icon-path": "inner-path"
  })), children);
});
var HelpFilled20 = /*#__PURE__*/React.forwardRef(function HelpFilled20(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
    "data-icon-path": "inner-path"
  })), children);
});
var HelpFilled16 = /*#__PURE__*/React.forwardRef(function HelpFilled16(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
    "data-icon-path": "inner-path"
  })), children);
});
var HelpDesk32 = /*#__PURE__*/React.forwardRef(function HelpDesk32(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
  })), children);
});
var HelpDesk24 = /*#__PURE__*/React.forwardRef(function HelpDesk24(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
  })), children);
});
var HelpDesk20 = /*#__PURE__*/React.forwardRef(function HelpDesk20(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
  })), children);
});
var HelpDesk16 = /*#__PURE__*/React.forwardRef(function HelpDesk16(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10H21a3.0033 3.0033 0 00-3 3v6a2.0023 2.0023 0 002 2v7a2.0023 2.0023 0 002 2h4a2.0023 2.0023 0 002-2V21a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zm1 9H26v9H22V19H20V13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1zM20 5a4 4 0 114 4A4.0042 4.0042 0 0120 5zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 5zM14 16V13a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3v3H0v2H16V16zM4 13a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v3H4zM4 5A4 4 0 118 9 4.0042 4.0042 0 014 5zM6 5A2 2 0 108 3 2.0023 2.0023 0 006 5z"
  })), children);
});
var QHintonPlot32 = /*#__PURE__*/React.forwardRef(function QHintonPlot32(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
  })), children);
});
var QHintonPlot24 = /*#__PURE__*/React.forwardRef(function QHintonPlot24(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
  })), children);
});
var QHintonPlot20 = /*#__PURE__*/React.forwardRef(function QHintonPlot20(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
  })), children);
});
var QHintonPlot16 = /*#__PURE__*/React.forwardRef(function QHintonPlot16(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2zM10 2H14V6H10zM18 2H22V6H18zM26 2H30V6H26zM2 10H6V14H2zM10 10H14V14H10zM18 10H22V14H18zM26 10H30V14H26zM2 18H6V22H2zM10 18H14V22H10zM18 18H22V22H18zM26 18H30V22H26zM2 26H6V30H2zM10 26H14V30H10zM18 26H22V30H18zM26 26H30V30H26z"
  })), children);
});
var WatsonHealthHoleFilling32 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFilling32(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
var WatsonHealthHoleFilling24 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFilling24(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
var WatsonHealthHoleFilling20 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFilling20(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
var WatsonHealthHoleFilling16 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFilling16(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
var WatsonHealthHoleFillingCursor32 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor32(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "19",
    r: "4"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
var WatsonHealthHoleFillingCursor24 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor24(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "19",
    r: "4"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
var WatsonHealthHoleFillingCursor20 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor20(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "19",
    r: "4"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
var WatsonHealthHoleFillingCursor16 = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor16(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "19",
    r: "4"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
var Home32 = /*#__PURE__*/React.forwardRef(function Home32(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
  })), children);
});
var Home24 = /*#__PURE__*/React.forwardRef(function Home24(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
  })), children);
});
var Home20 = /*#__PURE__*/React.forwardRef(function Home20(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
  })), children);
});
var Home16 = /*#__PURE__*/React.forwardRef(function Home16(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
  })), children);
});
var Hospital32 = /*#__PURE__*/React.forwardRef(function Hospital32(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
  })), children);
});
var Hospital24 = /*#__PURE__*/React.forwardRef(function Hospital24(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
  })), children);
});
var Hospital20 = /*#__PURE__*/React.forwardRef(function Hospital20(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
  })), children);
});
var Hospital16 = /*#__PURE__*/React.forwardRef(function Hospital16(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
  })), children);
});
var HospitalBed32 = /*#__PURE__*/React.forwardRef(function HospitalBed32(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
  })), children);
});
var HospitalBed24 = /*#__PURE__*/React.forwardRef(function HospitalBed24(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
  })), children);
});
var HospitalBed20 = /*#__PURE__*/React.forwardRef(function HospitalBed20(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
  })), children);
});
var HospitalBed16 = /*#__PURE__*/React.forwardRef(function HospitalBed16(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
  })), children);
});
var Hotel32 = /*#__PURE__*/React.forwardRef(function Hotel32(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
  })), children);
});
var Hotel24 = /*#__PURE__*/React.forwardRef(function Hotel24(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
  })), children);
});
var Hotel20 = /*#__PURE__*/React.forwardRef(function Hotel20(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
  })), children);
});
var Hotel16 = /*#__PURE__*/React.forwardRef(function Hotel16(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
  })), children);
});
var Hourglass32 = /*#__PURE__*/React.forwardRef(function Hourglass32(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V21H15zM15 23H17V25H15z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
  })), children);
});
var Hourglass24 = /*#__PURE__*/React.forwardRef(function Hourglass24(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V21H15zM15 23H17V25H15z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
  })), children);
});
var Hourglass20 = /*#__PURE__*/React.forwardRef(function Hourglass20(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V21H15zM15 23H17V25H15z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
  })), children);
});
var Hourglass16 = /*#__PURE__*/React.forwardRef(function Hourglass16(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V21H15zM15 23H17V25H15z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
  })), children);
});
var Html32 = /*#__PURE__*/React.forwardRef(function Html32(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
  })), children);
});
var Html24 = /*#__PURE__*/React.forwardRef(function Html24(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
  })), children);
});
var Html20 = /*#__PURE__*/React.forwardRef(function Html20(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
  })), children);
});
var Html16 = /*#__PURE__*/React.forwardRef(function Html16(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
  })), children);
});
var HtmlReference32 = /*#__PURE__*/React.forwardRef(function HtmlReference32(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
  })), children);
});
var HtmlReference24 = /*#__PURE__*/React.forwardRef(function HtmlReference24(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
  })), children);
});
var HtmlReference20 = /*#__PURE__*/React.forwardRef(function HtmlReference20(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
  })), children);
});
var HtmlReference16 = /*#__PURE__*/React.forwardRef(function HtmlReference16(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
  })), children);
});
var Http32 = /*#__PURE__*/React.forwardRef(function Http32(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
  })), children);
});
var Http24 = /*#__PURE__*/React.forwardRef(function Http24(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
  })), children);
});
var Http20 = /*#__PURE__*/React.forwardRef(function Http20(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
  })), children);
});
var Http16 = /*#__PURE__*/React.forwardRef(function Http16(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
  })), children);
});
var Humidity32 = /*#__PURE__*/React.forwardRef(function Humidity32(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
  })), children);
});
var Humidity24 = /*#__PURE__*/React.forwardRef(function Humidity24(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
  })), children);
});
var Humidity20 = /*#__PURE__*/React.forwardRef(function Humidity20(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
  })), children);
});
var Humidity16 = /*#__PURE__*/React.forwardRef(function Humidity16(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
  })), children);
});
var HumidityAlt32 = /*#__PURE__*/React.forwardRef(function HumidityAlt32(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
  })), children);
});
var HumidityAlt24 = /*#__PURE__*/React.forwardRef(function HumidityAlt24(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
  })), children);
});
export { ForecastLightning_3016, ForecastLightning_3020, ForecastLightning_3024, ForecastLightning_3032, Fork16, Fork20, Fork24, Fork32, Forum16, Forum20, Forum24, Forum32, Forward_1016, Forward_1020, Forward_1024, Forward_1032, Forward_3016, Forward_3020, Forward_3024, Forward_3032, Forward_516, Forward_520, Forward_524, Forward_532, Fragile16, Fragile20, Fragile24, Fragile32, FruitBowl16, FruitBowl20, FruitBowl24, FruitBowl32, Function16, Function20, Function24, Function32, FunctionMath16, FunctionMath20, FunctionMath24, FunctionMath32, GameConsole16, GameConsole20, GameConsole24, GameConsole32, GameWireless16, GameWireless20, GameWireless24, GameWireless32, Gamification16, Gamification20, Gamification24, Gamification32, GasStation16, GasStation20, GasStation24, GasStation32, GasStationFilled16, GasStationFilled20, GasStationFilled24, GasStationFilled32, GenderFemale16, GenderFemale20, GenderFemale24, GenderFemale32, GenderMale16, GenderMale20, GenderMale24, GenderMale32, GeneratePdf16, GeneratePdf20, GeneratePdf24, GeneratePdf32, Gif16, Gif20, Gif24, Gif32, Gift16, Gift20, Gift24, Gift32, Globe16, Globe20, Globe24, Globe32, Gradient16, Gradient20, Gradient24, Gradient32, GraphicalDataFlow16, GraphicalDataFlow20, GraphicalDataFlow24, GraphicalDataFlow32, Grid16, Grid20, Grid24, Grid32, Group16, Group20, Group24, Group32, GroupPresentation16, GroupPresentation20, GroupPresentation24, GroupPresentation32, Growth16, Growth20, Growth24, Growth32, Hail16, Hail20, Hail24, Hail32, Harbor16, Harbor20, Harbor24, Harbor32, Hashtag16, Hashtag20, Hashtag24, Hashtag32, Haze16, Haze20, Haze24, Haze32, HazeNight16, HazeNight20, HazeNight24, HazeNight32, Hd16, Hd20, Hd24, Hd32, HdFilled16, HdFilled20, HdFilled24, HdFilled32, Hdr16, Hdr20, Hdr24, Hdr32, Headphones16, Headphones20, Headphones24, Headphones32, Headset16, Headset20, Headset24, Headset32, HealthCross16, HealthCross20, HealthCross24, HealthCross32, Hearing16, Hearing20, Hearing24, Hearing32, HeatMap16, HeatMap20, HeatMap24, HeatMap32, HeatMapStocks16, HeatMapStocks20, HeatMapStocks24, HeatMapStocks32, HeatMap_0216, HeatMap_0220, HeatMap_0224, HeatMap_0232, HeatMap_0316, HeatMap_0320, HeatMap_0324, HeatMap_0332, Helicopter16, Helicopter20, Helicopter24, Helicopter32, Help16, Help20, Help24, Help32, HelpDesk16, HelpDesk20, HelpDesk24, HelpDesk32, HelpFilled16, HelpFilled20, HelpFilled24, HelpFilled32, Home16, Home20, Home24, Home32, Hospital16, Hospital20, Hospital24, Hospital32, HospitalBed16, HospitalBed20, HospitalBed24, HospitalBed32, Hotel16, Hotel20, Hotel24, Hotel32, Hourglass16, Hourglass20, Hourglass24, Hourglass32, Html16, Html20, Html24, Html32, HtmlReference16, HtmlReference20, HtmlReference24, HtmlReference32, Http16, Http20, Http24, Http32, Humidity16, Humidity20, Humidity24, Humidity32, HumidityAlt24, HumidityAlt32, QH16, QH20, QH24, QH32, QHintonPlot16, QHintonPlot20, QHintonPlot24, QHintonPlot32, WatsonHealthFusionBlender16, WatsonHealthFusionBlender20, WatsonHealthFusionBlender24, WatsonHealthFusionBlender32, WatsonHealthHangingProtocol16, WatsonHealthHangingProtocol20, WatsonHealthHangingProtocol24, WatsonHealthHangingProtocol32, WatsonHealthHoleFilling16, WatsonHealthHoleFilling20, WatsonHealthHoleFilling24, WatsonHealthHoleFilling32, WatsonHealthHoleFillingCursor16, WatsonHealthHoleFillingCursor20, WatsonHealthHoleFillingCursor24, WatsonHealthHoleFillingCursor32 };